import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';
import ExampleCloseButton from '../example-buttons/ExampleCloseButton.vue';

# Adding or Editing Ingest Locations

## Name

The descriptive name for the Ingest Location, this is just for your reference and can be anything.

## File Directory

This is the absolute path of the folder. ie. `C:\Users\YourName\Desktop\ExampleIngestLocation`

<v-alert
  icon="mdi-information-outline"
  color='info'
  density='compact'
  title="Note"
  text="You do not need to create a folder in this location, if the folder doesn't exist CanvasPro will create it for you."
/>

## Tag Ingest Assets

These are all the Tags you wish the assets ingested via this folder to have, you can select multiple tags.

## Saving

Once you're happy with your Ingest location, click <ExampleSaveButton /> to save. Or click the (<ExampleCloseButton />) button (top right) to cancel.
